export default function ForgetPassword() {
  return (
    <div className="p-10 text-3xl font-bold">ForgetPassword</div>
  )
}
